import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=6f9c0702&scoped=true&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"
import style0 from "./Card.vue?vue&type=style&index=0&id=6f9c0702&prod&lang=less&"
import style1 from "./Card.vue?vue&type=style&index=1&id=6f9c0702&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c0702",
  null
  
)

export default component.exports